import { Component, inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ERROR_VIEW_OPTIONS } from '@catalogues';
import { ErrorViewOption, ErrorViewType } from '@models';

@Component({
  selector: 'error-view',
  templateUrl: './error-view.component.html',
  styleUrl: './error-view.component.scss'
})
export class ErrorViewComponent implements OnInit {
  @Input() type?: ErrorViewType;
  private route: ActivatedRoute = inject(ActivatedRoute);
  private data = inject<Record<'option', ErrorViewType> | null>(MAT_DIALOG_DATA, {
    optional: true
  });
  option!: ErrorViewOption;

  ngOnInit() {
    this.option = ERROR_VIEW_OPTIONS[this.getResolvedType()];
  }

  private getResolvedType(): ErrorViewType {
    if (this.type) return this.type;
    if (this.data) return this.data.option;

    return this.route.snapshot.data['type'];
  }
}
